/**
 * Created by Rodrigo Quesada on 01/05/17.
 */
export class LocumTenensInfo {
    wasLocumTenensPosition?: boolean;
    companyName?: string;

    constructor(jsonData: any = {}) {
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/common/values/locum-tenens-info.class.ts